import { ReactComponent as StylizedGlobe } from '../assets/stylized-globe.svg';

type StylizedIconName = 'globe';

export const CircleStylizedIcon = ({
    name,
    height = 16,
    width,
}: {
    name: StylizedIconName;
    height?: number;
    width?: number;
}) => {
    switch (name) {
        case 'globe':
            return <StylizedGlobe height={height} width={width} />;
    }

    return null;
};
